module.exports = __webpack_public_path__ + "static/img/marjan-grabowski-HgcdpLIa5jo-unsplash.570ff20.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/marjan-grabowski-HgcdpLIa5jo-unsplash.jpg
// module id = fjsk
// module chunks = 1